import { useTheme } from "next-themes"
import { Toaster as Sonner, toast } from "sonner"

const Toaster = ({
  ...props
}) => {
  const { theme = "system" } = useTheme()

  return (
    <Sonner
      theme="light"
      className="toaster group"
      toastOptions={{
        classNames: {
          toast:
            "group toast group-[.toaster]:bg-white group-[.toaster]:text-black group-[.toaster]:border-gray-200 group-[.toaster]:shadow-lg",
          description: "group-[.toast]:text-gray-700",
          actionButton:
            "group-[.toast]:bg-[#571925] group-[.toast]:text-white",
          cancelButton:
            "group-[.toast]:bg-gray-200 group-[.toast]:text-gray-700",
          success: "group-[.toast]:text-green-700",
          error: "group-[.toast]:text-red-700",
          warning: "group-[.toast]:text-orange-700",
          info: "group-[.toast]:text-blue-700",
        },
        style: {
          background: '#ffffff',
          color: '#000000',
          border: '1px solid #e5e7eb',
        },
      }}
      {...props} />
  );
}

export { Toaster, toast }
